import { House, Archive, ShieldCheck, Bank, Handshake, TrendUp } from "@phosphor-icons/react";

export function getClientNavItems(unlockedModules = [], role = "client") {
  if (role === "affiliate") {
    return [
      { to: "/client/affiliate", label: "Sales Reps", icon: <Handshake size={18} weight="duotone" />, testId: "nav-client-affiliate" },
    ];
  }
  const items = [
    { to: "/client", label: "Dashboard", icon: <House size={18} weight="duotone" />, testId: "nav-client-dashboard" },
    { to: "/client/archive", label: "Report Archive", icon: <Archive size={18} weight="duotone" />, testId: "nav-client-archive" },
  ];
  if ((unlockedModules || []).includes("trust")) {
    items.push({ to: "/client/trust", label: "Trust & Asset Protection", icon: <ShieldCheck size={18} weight="duotone" />, testId: "nav-client-trust" });
  }
  if ((unlockedModules || []).includes("funding")) {
    items.push({ to: "/client/funding", label: "Business Funding", icon: <Bank size={18} weight="duotone" />, testId: "nav-client-funding" });
  }
  if ((unlockedModules || []).includes("affiliate")) {
    items.push({ to: "/client/affiliate", label: "Sales Reps", icon: <Handshake size={18} weight="duotone" />, testId: "nav-client-affiliate" });
  }
  if ((unlockedModules || []).includes("funding_pipeline")) {
    items.push({ to: "/client/funding-pipeline", label: "Funding Pipeline", icon: <TrendUp size={18} weight="duotone" />, testId: "nav-client-funding-pipeline" });
  }
  return items;
}
